import { render, staticRenderFns } from "./ViewIntro.vue?vue&type=template&id=45d1de24"
import script from "./ViewIntro.vue?vue&type=script&lang=js"
export * from "./ViewIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports